<template>
    <!-- <v-container> -->
        <div class="margen">
        <!-- TABLA USUARIOS -->

        <v-snackbar v-model="snackbarEditado" :timeout="4000" color="success" >
            <span class="mx-2"> {{mensajeSnackbar}} </span>
            
            <v-btn text dark @click="snackbarEditado=!snackbarEditado"> Cerrar </v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title >
                <div>
                    <div>
                        Usuarios
                    <ModalAgregar 
                    @actualizarTabla="actualizarTabla"
                    @mostrarSnackbar="mostrarSnackbar" />
                    </div>
                </div>

                <v-divider dark class="ma-4" inline></v-divider>
                <v-divider dark class="ma-4" inline></v-divider>

                <v-text-field v-model="buscador"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details></v-text-field>

            </v-card-title>

            <v-data-table class="elevation-1" 
            :headers=   "columnas"
            :items=     "datos" 
            :items-per-page="10"
            :search="buscador"
            :loading="cargando"
            >

                <template v-slot:[`item.actionEditar`]="{ item }">
                    <!-- @click.stop="btnEditarUsuario(item.USUARIO_ID)" -->
                    <!-- Se le pasa el prop 'infoUsuario' al componente ModalEditar
                    Y se le agrega una funcion @actualizarTabla que se llama desde 
                    el componente.-->
                    <ModalEditar :infoUsuario = item 
                    :key="item.USUARIO_ID"
                    @actualizarTabla="actualizarTabla"
                    @mostrarSnackbar="mostrarSnackbar" />

                </template>

                <template  v-slot:[`item.actionEstatus`]="{ item }">
                    
                    <ModalEstatus :infoUsuario="item"
                    :key="item.USUARIO_ID"
                    @actualizarTabla="actualizarTabla"
                    @mostrarSnackbar="mostrarSnackbar" />

                </template>
                
                <template slot="no-data">
                    <v-alert class="my-2" :value="true" type="info" color="red lighten-2" >
                        No se encontro informacion para mostrar.
                    </v-alert>
                </template>

            </v-data-table>
            
        </v-card>
        <!-- / TERMINO LA TABLA DE USUARIOS  -->


        
        

    <!-- </v-container> -->
        </div>
</template>

<script>

import { mapGetters } from 'vuex';
import axios from 'axios';
import ModalAgregar from './ModalAgregar.vue';
import ModalEditar from './ModalEditar.vue';
import ModalEstatus from './ModalEstatus.vue';

// import axios from 'axios';

export default {
  components: { ModalAgregar , ModalEditar , ModalEstatus },
    
    //Estatus:  A = Activo
    //          B = Baja
    
    // validar el login del usuario con los estatus 

    data() {
        return {

            datos:[],

            buscador:'',
            cargando: true,
            snackbarEditado:false, mensajeSnackbar:'',
            mostrarModal:false,

            columnas: [
                {text: "Usuario",           value:"USUARIO",      class:'primary lighten-1 white--text'},
                {text: "Nombre.",           value:"NOMBRE",       class:'primary lighten-1 white--text'},
                {text: "Apellido Paterno.", value:"APELLIDO_P",   class:'primary lighten-1 white--text'},
                {text: "Apellido Materno.", value:"APELLIDO_M",   class:'primary lighten-1 white--text'},
                {text: "Correo.",           value:"CORREO",       class:'primary lighten-1 white--text'},
                {text: "Editar.",           value:"actionEditar", class:'primary lighten-1 white--text', sortable:false,},
                {text: "Accion Estatus.",   value:"actionEstatus",class:'primary lighten-1 white--text', sortable:false,},
            ],

        }
    },

    computed: {
        // ...mapActions(['setUsuarios']),
        ...mapGetters(['getTotalUsuarios','getURLAPI']),

        // checarEstatus( id ){

        // }

    },

    methods: {
        async actualizarTabla(){
            // this.$store.dispatch('setUsuarios')
            // .then( (result) => this.datos = result ,
            // this.cargando = false )
            this.datos=[];
            try{
                this.cargando = true;
                this.datos = (await axios.get(`${this.getURLAPI}/Show/all`)).data
                this.cargando = false;

            }catch(e){
                this.cargando = false;
                console.log(this.datos + "Falló");

            }
        },

        mostrarSnackbar( mensaje ){
            this.snackbarEditado = true;
            this.mensajeSnackbar = mensaje.MSG;
        }

    },
    created() {
        document.title = "Usuarios | Bombas y Suministros del Norte"
        this.actualizarTabla()
        // ...mapGetters('getTotalUsuarios')
        // this.datos = this.getTotalUsuarios;
        console.log(this.datos);
        
    },


}

</script>

<style>

.margen{
    margin-top: 1px;
}
</style>